import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { DatePicker, Descriptions, Select } from 'antd';
import { SEMESTER_TYPE } from '../../../constans';
const { Option } = Select;

interface IProps {
  yearList: any;
  semesterInput: any;
  setSemesterInput: Function;
  isDisabled: boolean;
  termList: any;
  typeList: any;
}

const SemesterInfo: FC<IProps> = ({
  yearList,
  termList,
  typeList,
  semesterInput,
  setSemesterInput,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const onSetSemesterInput = (key: string, value: any) => {
    setSemesterInput({ ...semesterInput, [key]: value });
  }
  
  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        column={2}
        size="small"
      >
        <Descriptions.Item label={t('program.semester.column9')}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={semesterInput.year}
              onChange={value => onSetSemesterInput('year', value)}
              disabled={isDisabled}
            >
              {
                yearList?.slice(1).map((item: any) => {
                  return (
                    <Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Option>
                  )
                })
              }
            </Select>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('program.semester.column11')}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={semesterInput.type}
              onChange={value => {
                setSemesterInput({ ...semesterInput, ['type']: value, ['startDate']:null, ['endDate']:null, ['term']:null});
              }}
              disabled={isDisabled || semesterInput.semesterCode}
            >
              {
                typeList?.map((item: any) => {
                  return (
                    <Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Option>
                  )
                })
              }
            </Select>
          </div>
        </Descriptions.Item>        
        <Descriptions.Item label={t('program.semester.column10')}>
          <div className="w-150p">
            <input
              type="text"
              className="form-control input-text"
              value={semesterInput.name}
              onChange={e => onSetSemesterInput('name', e.target.value)}
              disabled={isDisabled}
            />
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.semester')}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={semesterInput.term}
              onChange={value => onSetSemesterInput('term', value)}
              disabled={isDisabled || !semesterInput.type}
            >
              {
                termList?.slice(1).map((item: any) => {
                  if(item.type === semesterInput.type) {
                    return (
                      <Option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Option>
                    )
                  }
                })
              }
            </Select>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('program.semester.column12')}>
          <div className="w-150p date-picker__area">
            <DatePicker
              className="w-100"
              value={
                semesterInput.startDate
                  ? moment(semesterInput.startDate)
                  : undefined
              }
              onChange={e => {
                if (e === null) onSetSemesterInput('startDate', null);
                else onSetSemesterInput('startDate', moment(e).format('YYYY-MM-DD'));
              }}
              disabled={isDisabled || (SEMESTER_TYPE.SPECIAL_CLASS === semesterInput.type)}
            />          
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('program.semester.column13')}>
          <div className="w-150p date-picker__area">
            <DatePicker
              className="w-100"
              value={
                semesterInput.endDate
                  ? moment(semesterInput.endDate)
                  : undefined
              }
              onChange={e => {
                if (e === null) onSetSemesterInput('endDate', null);
                else onSetSemesterInput('endDate', moment(e).format('YYYY-MM-DD'));
              }}
              disabled={isDisabled || (SEMESTER_TYPE.SPECIAL_CLASS === semesterInput.type)}
            />
          </div>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}

export default SemesterInfo;
